import BundleReturn from './content/BundleReturn';
import bundleStore from '../../store/bundleStore';
import React from 'react';
import Confirm from "./content/Confirm";
import DirectReturn from "./content/DirectReturn";
import {readDirectReturn} from "../../utils/pgDirect";


const ConfirmInfo = ({ setPage,
                         reValid,
                         setReValid,
                         read,
                         setRead,
                         read2,
                         setRead2,
                         setSms,
    sms
}) => {

    const direct = readDirectReturn();
    // 묶음 주문번호(RB…)는 저장된 결제 정보가 없어도(다른 탭·브라우저 복귀) 묶음 상태 조회로 간다 — 단건 API 로 보내지 않는다.
    if (sessionStorage.getItem('bundlePayment') || bundleStore.result || direct?.moid.startsWith('RB')) return <BundleReturn />;
    if (direct) return (
        <Confirm setPage={setPage} setReValid={setReValid} setRead={setRead} setRead2={setRead2}>
            <DirectReturn moid={direct.moid} result={direct.result} setSms={setSms} sms={sms}/>
        </Confirm>
    );

    return (
        <Confirm setPage={setPage} setReValid={setReValid} setRead={setRead} setRead2={setRead2}>
            <Confirm.Data setSms={setSms} sms={sms}/>
        </Confirm>
    );
};



export default ConfirmInfo;
